import { InfoCircle } from '@/public/icons/tsx';
import * as React from 'react';
import { Typography } from '../typography';

export const ErrorMessageInput: React.FC<{
	message: string;
	withOutIcon?: boolean;
}> = ({ message, withOutIcon = false }) => {
	return (
		<div className="flex items-center gap-x-1.5 mt-1">
			{!withOutIcon && (
				<InfoCircle
					fill="#FF0043"
					width="16"
					height="16"
					className="flex-shrink-0"
				/>
			)}
			<span className="flex items-center mt-1 gap-1">
				<Typography type="regular-12" className="text-main-red">
					{message}
				</Typography>
			</span>
		</div>
	);
};
